export enum DateLabels {
  START_DATE = 'Start Date',
  DEADLINE = 'courses.item.deadline',
}
